import { isClient } from '@vueuse/core'
export class AppUtils {
  terminal?: 'ios' | 'android'
  jcAppMessageHandler?: any

  constructor() {
    let terminal: 'ios' | 'android' | undefined
    if (isClient) {
      if (window?.webkit?.messageHandlers?.jcAppMessageHandler) {
        terminal = 'ios'
      }
      if (window?.jcAppMessageHandler) {
        terminal = 'android'
      }

      this.terminal = terminal
      this.jcAppMessageHandler =
        window?.webkit?.messageHandlers?.jcAppMessageHandler ||
        window?.jcAppMessageHandler
    }
  }

  isApp: boolean =
    Boolean(
      window?.webkit?.messageHandlers?.jcAppMessageHandler?.postMessage,
    ) || Boolean(window?.jcAppMessageHandler?.postMessage)

  postMessage<T = any>(
    method: string,
    params?: Record<string, any>,
  ): Promise<T> {
    const name = `APP_CALLBACK_${method}`

    return new Promise((resolve, reject) => {
      try {
        if (this.terminal == 'ios') {
          ;(window as any)[name] = (res: string) => {
            resolve(JSON.parse(res))
            delete (window as any)[name]
          }
        }
        const messageData = JSON.stringify({
          method: method,
          callBack: name,
          params: params,
        })
        const proms = this.jcAppMessageHandler?.postMessage(messageData)
        if (this.terminal === 'android') {
          resolve(JSON.parse(proms || '{}'))
        }
      } catch (err) {
        console.error(err)
        reject(err)
      }
    })
  }

  // Return to the app
  backApp(): Promise<void> {
    return this.postMessage('goBack', {})
  }

  // Get app language
  getLang(): Promise<string> {
    return this.postMessage('lang', {})
  }

  // 登录
  login(url: string, clicksource: string): Promise<void> {
    return this.postMessage('login', { url, clicksource })
  }

  register(data: any): Promise<void> {
    return this.postMessage('register', { ...data })
  }

  // 名录搜索条件同步 接收到调用后，将首页的搜索条件清空

  syncCondition(): Promise<void> {
    return this.postMessage('syncCondition', {})
  }

  /**
   * H5打开IM：@纪宇航
方法名：openIM
	参数：
		path（进入URL）：H5页面当前url（由H5页面传递参数到原生）
		imTarget（IM聊天对象）：聊天目标ID（同目前小程序拉起IM）
		imMode（IM聊天模式）：C2C还是C2B等（同目前小程序拉起IM）
	原生功能：
		1）打开指定目标的IM聊天窗口
		2）关闭窗口后，打开H5页面（URL=入参url）

   */
  openIM(
    path: string,
    imTarget: string,
    imMode: 'C2C' | 'C2B' | 'C2G' = 'C2C',
    serviceType: 'service' | 'default' = 'default',
  ) {
    return this.postMessage('openIM', {
      path,
      imTarget,
      imMode,
      serviceType,
    })
  }
}
